import Select from "@/v2-ui/select"
import {
  PORTFOLIO_TIMEFRAMES,
  type PortfolioTimeframeKey,
} from "@/v2-backoffice-client/portfolio/portfolio.filters"

export type PortfolioTimeframeSelectProps = {
  value: PortfolioTimeframeKey
  onChange(key: PortfolioTimeframeKey): void
}

// Timeframe control for ONE time-series section (daily activity,
// geography sign-ins). Deliberately per-section rather than global: the
// profile-derived signals (scores, churn, plays) are computed upfront in
// Databricks on a fixed 28-day window and cannot re-window, so a global
// selector would promise more than the data can deliver.
function PortfolioTimeframeSelect(props: PortfolioTimeframeSelectProps) {
  const { value, onChange } = props

  return (
    <div className="w-36 shrink-0">
      <Select
        value={value}
        onValueChange={(next) => onChange(next as PortfolioTimeframeKey)}
      >
        <Select.Trigger size="xs">
          <Select.Value placeholder="Timeframe" />
        </Select.Trigger>
        <Select.Content>
          {PORTFOLIO_TIMEFRAMES.map((timeframe) => (
            <Select.Item key={timeframe.key} value={timeframe.key}>
              {timeframe.label}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
    </div>
  )
}

export default PortfolioTimeframeSelect
